import { useMutation, useQuery } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { ITaskState } from "../../interfaces/ITaskState";
import { ITaskPriority } from "../../interfaces/ITaskPriority";
import { ITaskType } from "../../interfaces/ITaskType";

export const useGetTaskState = () => {
    const {
        data: taskStateArray,
        isLoading: isLoadingTaskState,
        refetch: refetchTaskStateTask,
    } = useQuery<ITaskState[]>({
        queryKey: ["task/state/"],
        queryFn: () => customFetcher({ endpoint: "/task/state/" }),
    });
    return { taskStateArray, isLoadingTaskState, refetchTaskStateTask };
};

export const useGetTaskPriority = () => {
    const {
        data: taskPriorityArray,
        isLoading: isLoadingTaskPriority,
        refetch: refetchTaskPriorityTask,
    } = useQuery<ITaskPriority[]>({
        queryKey: ["task/priority/"],
        queryFn: () => customFetcher({ endpoint: "/task/priority/" }),
    });
    return { taskPriorityArray, isLoadingTaskPriority, refetchTaskPriorityTask };
};

export const useGetTaskType = () => {
    const {
        data: taskTypeArray,
        isLoading: isLoadingTaskType,
        refetch: refetchTaskTypeTask,
    } = useQuery<ITaskType[]>({
        queryKey: ["task/type/"],
        queryFn: () => customFetcher({ endpoint: "/task/type/" }),
    });
    return { taskTypeArray, isLoadingTaskType, refetchTaskTypeTask };
};
